/**
 * WorkflowSheet
 * Mobile bottom sheet that opens when the WorkflowLauncher pill is tapped.
 * Uses the existing shadcn Sheet primitive with side="bottom".
 */

import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '../ui/sheet';
import { WorkflowList } from './WorkflowList';

interface WorkflowSheetProps {
  open: boolean;
  onClose: () => void;
}

export function WorkflowSheet({ open, onClose }: WorkflowSheetProps) {
  return (
    <Sheet open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <SheetContent
        side="bottom"
        data-testid="workflow-sheet"
        className="max-h-[80vh] overflow-y-auto rounded-t-xl p-0"
        aria-label="Workflow panel"
        aria-modal="true"
      >
        <SheetHeader className="px-4 pt-4 pb-2 border-b border-border">
          <SheetTitle>Workflows</SheetTitle>
          <SheetDescription className="sr-only">
            View and manage your active workflows
          </SheetDescription>
        </SheetHeader>
        <WorkflowList />
      </SheetContent>
    </Sheet>
  );
}
